import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { useCrmLocale } from '../../ui/locale/crmLocale';
import './CrmTable.css';

export type CrmFilterBarProps = ComponentPropsWithoutRef<'div'> & { actions?: ReactNode };

/** Slots retain each page's live/apply, reset, dependencies and query behavior. */
export function CrmFilterBar({ children, actions, className = '', 'aria-label': label, ...props }: CrmFilterBarProps) {
  const { t } = useCrmLocale();
  return <div {...props} role="group" aria-label={label ?? t('Filters')} className={`crm-filter-bar ${className}`}>
    <div className="crm-filter-bar__fields">{children}</div>
    {actions && <div className="crm-filter-bar__actions">{actions}</div>}
  </div>;
}

export type CrmTableControlsProps = ComponentPropsWithoutRef<'div'> & { actions?: ReactNode };

export function CrmTableControls({ children, actions, className = '', ...props }: CrmTableControlsProps) {
  return <div {...props} className={`crm-table-controls ${className}`}>
    <div className="crm-table-controls__context">{children}</div>
    {actions && <div className="crm-table-controls__actions">{actions}</div>}
  </div>;
}
